class stateDay {
  constructor(
    id,
    diaSem,
    diaSemEx,
    diaAus,
    diaInc,
    diaHca,
    diaTar,
    diaRet,
    diaLiD,
    diaLiH,
    diaExt,
    horasLab,
    horasTrab,
    horHorario,
    horSegmento,
    Elementos,
    Liquidaciones,
  ) {
    this.id = id;
    this.diaSem = diaSem;
    this.diaSemEx = diaSemEx;
    this.diaAus = diaAus;
    this.diaInc = diaInc;
    this.diaHca = diaHca;
    this.diaTar = diaTar;
    this.diaRet = diaRet;
    this.diaLiD = diaLiD;
    this.diaLiH = diaLiH;
    this.diaExt = diaExt;
    this.horasLab = horasLab;
    this.horasTrab = horasTrab;
    this.horHorario = horHorario;
    this.horSegmento = horSegmento;
    this.Elementos = Elementos;
    this.Liquidaciones = Liquidaciones;
  }
  static fromJson({
    id,
    diaSem,
    diaSemEx,
    diaAus,
    diaInc,
    diaHca,
    diaTar,
    diaRet,
    diaLiD,
    diaLiH,
    diaExt,
    horasLab,
    horasTrab,
    horHorario,
    horSegmento,
    Elementos,
    Liquidaciones,
  }) {
    return new stateDay(
      id,
      diaSem,
      diaSemEx,
      diaAus,
      diaInc,
      diaHca,
      diaTar,
      diaRet,
      diaLiD,
      diaLiH,
      diaExt,
      horasLab,
      horasTrab,
      horHorario,
      horSegmento,
      Elementos,
      Liquidaciones,
    );
  }
}
export default stateDay;
